import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-viewsupportter',
  templateUrl: './viewsupportter.component.html',
  styleUrls: ['./viewsupportter.component.css']
})
export class ViewsupportterComponent implements OnInit , OnDestroy {
  userdata:any;
  constructor(private auth: Authenticationservice,private spinner: NgxSpinnerService) {
    this.userdata = this.auth.Authention();
   }

  tab = 1;
  ngOnInit(): void {
    this.LoadSumsupportter();
    this.LoadCaneinsupportter();
  }
  ngOnDestroy(): void {
      this.sumsupportterdata = null;
      this.caninsupportterdata = null;
  }

  sumsupportterdata:any;
  LoadSumsupportter(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_vw_Dashboard_Planting_6566_w?supcode="+this.userdata.supcode;
    this.spinner.show();
    axios.get(url).then(res=> {
     this.sumsupportterdata  =  res.data.recordset;
     this.spinner.hide();
    }).catch(err => { this.spinner.hide(); 
      throw (err) })
    }

    caninsupportterdata:any;
    LoadCaneinsupportter(){
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_canein_supcode_w?supcode="+this.userdata.supcode;
      this.spinner.show();
      axios.get(url).then(res=> {
       this.caninsupportterdata  =  res.data.recordset;
       this.spinner.hide();
      }).catch(err => { this.spinner.hide(); 
        throw (err) })
    }

}
